import React, { useState } from 'react';
import './ContactPage.css';
// We'll need to install the EmailJS package
// npm install @emailjs/browser

import emailjs from '@emailjs/browser';

const ContactPage = () => {
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  
  // Form submission state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });
  
  // Validation state
  const [errors, setErrors] = useState({});
  
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };
  
  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }
    
    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!validateForm()) {
      return;
    }
    
    // Set submitting state
    setIsSubmitting(true);
    
    try {
      // Send email with EmailJS
      const result = await emailjs.send(
        'service_5ed76qu', // Replace with your EmailJS service ID
        'template_kqxqcyi', // Replace with your EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company,
          message: formData.message
        },
        'Whn-eySgbpPMZCEs_' // Replace with your EmailJS public key
      );
      
      console.log('Email sent successfully:', result.text);
      
      // Show success message
      setSubmitStatus({
        submitted: true,
        success: true,
        message: 'Thank you for your message! We\'ll be in touch soon.'
      });
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        company: '',
        message: ''
      });
      
    } catch (error) {
      // Handle error
      console.error('Form submission error:', error);
      setSubmitStatus({
        submitted: true,
        success: false,
        message: 'Something went wrong. Please try again or contact us directly.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
  <section className="contact-section">
    <div className="contact-background"></div>
    <div className="contact-container">
      <div className="contact-grid">
        <div className="contact-info">
          <div className="contact-title">get in touch</div>
          <div className="contact-description">
            Ready to discuss your next project? Contact us to start a conversation about how we can bring your brand story to life.
          </div>
          <div className="contact-details">
            {/* <div className="contact-details-title">Contact Information</div> */}
            <div className="contact-details-item">Email: hello@sterlingrainprojects.com</div>
          </div>
        </div>
        <div>
          <div className="contact-form-wrapper">
            {submitStatus.submitted && submitStatus.success ? (
              <div className="form-success">
                <div className="success-title">Message Sent</div>
                <div className="success-message">{submitStatus.message}</div>
                <button 
                  className="custom-btn custom-btn-primary"
                  onClick={() => setSubmitStatus({ submitted: false, success: false, message: '' })}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="form-label">Name</div>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`form-input ${errors.name ? 'input-error' : ''}`}
                    placeholder="Your name"
                  />
                  {errors.name && <div className="error-message">{errors.name}</div>}
                </div>
                <div className="form-group">
                  <div className="form-label">Email</div>
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`form-input ${errors.email ? 'input-error' : ''}`}
                    placeholder="Your email"
                  />
                  {errors.email && <div className="error-message">{errors.email}</div>}
                </div>
                <div className="form-group">
                  <div className="form-label">Company</div>
                  <input 
                    type="text" 
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Your company"
                  />
                </div>
                <div className="form-group">
                  <div className="form-label">Project Details</div>
                  <textarea 
                    rows="5" 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className={`form-textarea ${errors.message ? 'input-error' : ''}`}
                    placeholder="Tell us about your project"
                  ></textarea>
                  {errors.message && <div className="error-message">{errors.message}</div>}
                </div>
                <button 
                  type="submit" 
                  className="custom-btn custom-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
                {submitStatus.submitted && !submitStatus.success && (
                  <div className="error-message submit-error">{submitStatus.message}</div>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default ContactPage;


            // <div>
            //   <h3 className="contact-details-title">Follow Us</h3>
            //   <div className="social-links">
            //     <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
            //     <a href="https://vimeo.com/" target="_blank" rel="noopener noreferrer" className="social-link">Vimeo</a>
            //     <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
            //   </div>
            // </div>